// var languageType = require('./languageCommon.js')
var languageType = require('./languageCommon.js')
var language = localStorage.getItem('language') || 'zh-CN'
if(language=='zh-CN'){
    document.getElementsByTagName('meta')[1].setAttribute('content',groupmeta[language])
    document.getElementsByTagName('meta')[2].setAttribute('content',groupkey[language])
    document.title = grouptitle[language];
}else{
    document.getElementsByTagName('meta')[1].setAttribute('content',groupmeta['USA'])
    document.getElementsByTagName('meta')[2].setAttribute('content',groupkey['USA'])
    document.title = grouptitle['USA'];
    // document.getElementsByTagName('title')[1].setAttribute('content',grouptitle['USA'])
}
$('.commonlanguage').html(commonlanguage[language])
$('title').html(groupTitle[language]);
$('.commonHomePage').html(commonHomePage[language]);
$('.commonLvyue').html(commonLvyue[language]);
$('.commonAboutLvyue').html(commonAboutLvyue[language]);
$('.commonlvyueBrand').html(commonlvyueBrand[language]);
$('.commonFlowerConstruction').html(commonFlowerConstruction[language]);
$('.commonFloralLux').html(commonFloralLux[language]);
$('.commonClaim').html(commonClaim[language]);
$('.commonWeiLai').html(commonWeiLai[language]);
$('.commonTanChen').html(commonTanChen[language]);
$('.commonflowerTravel').html(commonflowerTravel[language]);
$('.commonJoinInCooperation').html(commonJoinInCooperation[language]);
$('.commonPanorama').html(commonPanorama[language]);
// $('.commonPaidInformation').html(commonPaidInformation[language]);
$('.commonZh').html(commonZh[language]);
$('.commonUsa').html(commonUsa[language]);
$('.commonJp').html(commonJp[language]);
$('.commonKo').html(commonKo[language]);
$('.commonTh').html(commonTh[language]);
$('.commonYh').html(commonYh[language]);
$('.commonReservations a').html(commonReservations[language]);
$('.commonClose').html(commonClose[language]);
$('.commonFreebooking').html(commonFreebooking[language]);
$('.commonDownload').html(commonDownload[language]);
$('.commonWechatSubscription').html(commonWechatSubscription[language]);
$('.commonHuazhuSubscription').html(commonHuazhuSubscription[language]);
$('.commonBrandintroductio').html(commonBrandintroductio[language]);
$('.commonWantJoin').html(commonWantJoin[language]);
$('.commonConectUs').html(commonConectUs[language]);
$('.commonCustomerServiceHotline').html(commonCustomerServiceHotline[language]);
$('.commonConectChina').html(commonCustomerServiceHotlineChina[language]);
$('.commonConectPhilippines').html(commonCustomerServiceHotlinePhilippines[language]);
$('.commonConectJapan').html(commonCustomerServiceHotlineJapan[language]);
$('.commonConectKorea').html(commonCustomerServiceHotlineKorea[language]);
$('.commonConectThailand').html(commonCustomerServiceHotlineThailand[language]);
$('.commonConectYh').html(commonCustomerServiceHotlineYh[language]);
$('.commonCompanyInfo').html(commonCompanyInfo[language]);
$('.commonCompanyBeianInfo').html(commonCompanyBeianInfo[language]);
$('.commonCompanyBeianText').html(commonCompanyBeianText[language]);
$('.commonCompanyLicense').html(commonCompanyLicense[language]);
$('.commonCompanyICP').html(commonCompanyICP[language]);
$('.groupAboutLvyue').html(groupAboutLvyue[language])
$('.groupHope').html(groupHope[language]);
$('.groupHopeInfo').html(groupHopeInfo[language]);
$('.groupOurBusiness').html(groupOurBusiness[language]);
$('.groupIntegrateType1').html(groupIntegrateType1[language]);
$('.groupIntegrateType2').html(groupIntegrateType2[language]);
$('.groupIntegrateType3').html(groupIntegrateType3[language]);
$('.groupIntegrateType4').html(groupIntegrateType4[language]);
$('.groupIntegrateType5').html(groupIntegrateType5[language]);
$('.groupIntegrateType6').html(groupIntegrateType6[language]);
$('.groupIntegrateType7').html(groupIntegrateType7[language]);
$('.groupCoreCompetitiveness').html(groupCoreCompetitiveness[language]);
$('.groupBigData').html(groupBigData[language]);
$('.groupTeamContant').html(groupTeamContant[language]);
$('.groupSingleDimension').html(groupSingleDimension[language]);
$('.groupProgramme').html(groupProgramme[language]);
$('.groupCultureLeads').html(groupCultureLeads[language]);
$('.groupcultureLeadsInfo').html(groupcultureLeadsInfo[language]);
$('.commonLvyue1').html(commonLvyue1[language]);
$('.Leadership').html(Leadership[language]);
$('.TalentRecruitment').html(TalentRecruitment[language]);
$('.floralReservation').html(floralReservation[language]);
$('.commonBaina').html(commonBaina[language]);
$('.commonBanlan').html(commonBanlan[language]);



/** WEBPACK FOOTER **
 ** ./src/js/groupLanguage.js
 **/